<!-- Floating App Update Notification Banner -->
<div *ngIf="updateService.updateAvailable$ | async"
    class="fixed top-3 inset-x-3 sm:top-4 sm:max-w-md sm:mx-auto z-[99999] pointer-events-auto animate-fade-in">
    <div class="flex items-center justify-between gap-3 p-3 sm:p-3.5 bg-slate-900/95 text-white backdrop-blur-md rounded-2xl shadow-2xl border border-slate-700/60">
        <div class="flex items-center gap-2.5 min-w-0">
            <div class="w-8 h-8 rounded-xl bg-blue-600/30 border border-blue-400/40 flex items-center justify-center shrink-0 text-blue-400">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 animate-spin-slow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
                    <path d="M3 3v5h5"/>
                    <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
                    <path d="M16 21h5v-5"/>
                </svg>
            </div>
            <div class="flex flex-col min-w-0">
                <p class="text-xs font-semibold text-white truncate">
                    Versi Baru Tersedia
                </p>
                <p class="text-[11px] text-slate-300 truncate">
                    Pembaruan sistem siap dipasang
                </p>
            </div>
        </div>

        <div class="flex items-center gap-1.5 shrink-0">
            <button type="button" (click)="updateService.applyUpdate()" [disabled]="updateService.isUpdating$ | async"
                class="px-3 py-1.5 text-xs font-bold text-white bg-blue-600 hover:bg-blue-500 active:scale-95 transition rounded-xl shadow-sm flex items-center gap-1.5 disabled:opacity-50 cursor-pointer">
                <svg *ngIf="updateService.isUpdating$ | async" class="w-3.5 h-3.5 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <circle cx="12" cy="12" r="10" stroke-width="4" stroke-dasharray="32" stroke-linecap="round"/>
                </svg>
                <span>{{ (updateService.isUpdating$ | async) ? 'Memperbarui...' : 'Perbarui' }}</span>
            </button>
            <button type="button" (click)="updateService.dismiss()"
                class="p-1.5 text-slate-400 hover:text-white rounded-lg transition active:scale-90 cursor-pointer"
                title="Tutup pemberitahuan">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"/>
                    <line x1="6" y1="6" x2="18" y2="18"/>
                </svg>
            </button>
        </div>
    </div>
</div>

<app-alert></app-alert>
<app-loading-overlay></app-loading-overlay>
<div class="flex flex-col min-h-dvh">
  <!-- <img src="assets/wp_logo.png" alt="Warung Pangan Logo" class="block h-auto pt-6 mx-auto w-50" routerLink="/" /> -->
  <main class="flex-1">
    <router-outlet></router-outlet>
  </main>
  <footer *ngIf="showFooter" class="flex flex-col items-center justify-center gap-1 pb-5">
    <p class="text-xs font-medium text-primary">Powered by</p>
    <img src="assets/brand/idfood.png" alt="Warung Pangan Logo" class="w-32 h-auto md:w-40" />
  </footer>
</div>